<template>
  <generic-container
    :title="$t('occupation')"
    icon="user md"
    :header_buttons="header_buttons"
    :show_plus="true"
    @add="add"
  >
    <table
      class="ui blue very compact celled striped selectable table"
      ref="table"
      style="width:100%"
    >
      <thead>
        <tr>
          <th>{{ $t("name") }}</th>
          <th>{{ $t("options") }}</th>
        </tr>
      </thead>
      <tbody></tbody>
    </table>
    <enterprise-modal ref="enterprise_modal" @deleted="refresh" />
  </generic-container>
</template>

<script>
// import filters from "@/filters";
import GenericContainer from "@/components/GenericContainer";
import EnterpriseModal from "./enterprise_modal/EnterpriseModalIndex.vue";
import {
  init_ajax_data_datables,
  enterprise_setup,
  local_api,
  error_toast,
} from "@/utils";
// import filters from "@/filters";

export default {
  name: "RobocreditCatalogs",
  components: { "generic-container": GenericContainer, EnterpriseModal },
  data() {
    return {
      header_buttons: [
        {
          icon: "refresh",
          tooltip: this.$t("refresh"),
          click: this.refresh,
        },
      ],
      datatable: {},
    };
  },
  computed: {
    enterprise_setup() {
      return enterprise_setup(this);
    },
  },
  methods: {
    refresh() {
      this.init();
    },
    init() {
      let vm = this;
      let columns = [
        {
          data: function(row) {
            return row.name;
          },
        },
        {
          data: function(row) {
            return `<div class="ui mini icon button" onclick="window.dispatchEvent(new CustomEvent('edit_occupation', { detail: { id: ${row.occupation_id}, name: '${row.name}'}}))">
                      <i class="orange edit icon"></i>
                    </div>
                    <div class="ui mini red icon button" onclick="window.dispatchEvent(new CustomEvent('delete_occupation', { detail: { id: ${row.occupation_id}, name: '${row.name}'}}))">
                      <i class="trash icon"></i>
                    </div>`;
          },
        },
      ];

      let onSelect = () => {
        // vm.$refs.enterprise_modal.show_modal(data);
      };

      vm.datatable = init_ajax_data_datables(
        vm,
        vm.$refs.table,
        window.jQuery.fn.api.settings.api[
          "robocredit catalog banned occupation url"
        ],
        columns,
        onSelect,
      );
    },
    add() {
      let vm = this;
      vm.$alertify.prompt(this.$t("enter occupation name"), "", function(
        element,
        value,
      ) {
        if (value) {
          local_api(
            vm,
            "post",
            "/robocredit/catalog/do-save-banned-occupation",
            {
              n: value,
            },
          )
            .then(() => {
              vm.init();
            })
            .catch((err) => {
              error_toast(err);
            });
        }
      });
      // this.$refs.enterprise_modal.show_modal();
    },
  },
  mounted() {
    let vm = this;
    vm.init();
  },
  created() {
    let vm = this;
    window.addEventListener(
      "edit_occupation",
      function(e) {
        let enterprise_id = e.detail.id;
        let name = e.detail.name;
        vm.$alertify.prompt(vm.$t("enter occupation name"), name, function(
          element,
          value,
        ) {
          if (value) {
            local_api(
              vm,
              "post",
              "/robocredit/catalog/do-save-banned-occupation",
              {
                n: value,
                i: enterprise_id,
              },
            )
              .then(() => {
                vm.init();
              })
              .catch((err) => {
                error_toast(err);
              });
          }
        });
      },
      false,
    );

    window.addEventListener(
      "delete_occupation",
      function(e) {
        let enterprise_id = e.detail.id;
        vm.$alertify.confirm(
          vm.$t("are you sure to remove banned occupation?"),
          function() {
            local_api(
              vm,
              "post",
              "/robocredit/catalog/do-remove-banned-occupation",
              {
                i: enterprise_id,
              },
            )
              .then(() => {
                vm.init();
              })
              .catch((err) => {
                error_toast(err);
              });
          },
        );
      },
      false,
    );
  },
};
</script>
